import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_recursive_taxonomy_buttons = _resolveComponent("recursive-taxonomy-buttons")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTaxonomyTerms, (taxonomy, slug) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: slug }, [
      (false === _ctx.exclude.includes(slug))
        ? (_openBlock(), _createBlock(_component_recursive_taxonomy_buttons, {
            key: 0,
            ref_for: true,
            ref: "recursiveTaxonomyButtons",
            tax: taxonomy,
            slug: slug,
            onUpdateTaxonomy: _ctx.updateTaxonomy,
            "multi-select": _ctx.multiSelect,
            "show-terms": _ctx.showTerms
          }, null, 8, ["tax", "slug", "onUpdateTaxonomy", "multi-select", "show-terms"]))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}